import React, { useState } from "react";
import { CLOSEEYE, INPUT_INFO_ICON, OPENEYE } from "../../utils/app-image-contant";
import { Tooltip } from "react-tooltip";

const Password = ({
  labelName = "Password",
  placeholder = "Enter Your Password",
  handlePassword = function o() { },
  mandatory = true,
  payload,
  setPayload,
  error = false,
  Name,
  value,
  handleChange,
  info_Icon = false,
  tooltipContent="",
  id="",
  tooltipClassName=""
}) => {
  const [inputType, setInputType] = useState("password");
  const [eyeIconStatus, setEyeIconStatus] = useState("password");

  //   password field eye icon
  const handleEyeButton = () => {
    if (inputType === "text") {
      setInputType("password");
      setEyeIconStatus(true);
    } else {
      setInputType("text");
      setEyeIconStatus(false);
    }
  };

  return (
    <>
      <label className="form-label">{labelName}</label>{" "}{mandatory && <span className="text-red">*</span>}
      <div className="input-group input-group-merge">
        <input
          type={`${inputType}`}
          className={`form-control border-end-0 ${error && "border-danger bg-error"}`}
          placeholder={placeholder}
          name={Name}
          value={value}
          // onChange={(e) => setPayload(handleFormInput(e, payload))}
          onChange={handleChange}
        />
        <div className={`input-group-text inputText ${error && "border-danger bg-error"}`} data-password="false">
          <span className="password-eye" onClick={handleEyeButton}>
            {eyeIconStatus ? (
              <img src={OPENEYE} alt="OPENEYE" width="20px" className={`${info_Icon ? "me-3" : ""}`} />
            ) : (

              <img src={CLOSEEYE} alt="CLOSEEYE" width="20px" className={`${info_Icon ? "me-3" : ""}`} />
            )}
          </span>
          {info_Icon && <>
            <a data-tooltip-id={id} data-tooltip-content={tooltipContent} data-tooltip-place="top">
              <img
                src={INPUT_INFO_ICON}
                className="input-right-icon"
                alt="info-icon"
                width="18px"
              />
            </a>
            <Tooltip id={id} className={`example-pink ${tooltipClassName}`} />
          </>
          }
        </div>
      </div>
    </>
  );
};

export default Password;
